/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManageGmailResponse
 */
export interface ManageGmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ManageGmailResponse
     */
    message: string;
}

/**
 * Check if a given object implements the ManageGmailResponse interface.
 */
export function instanceOfManageGmailResponse(value: object): value is ManageGmailResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ManageGmailResponseFromJSON(json: any): ManageGmailResponse {
    return ManageGmailResponseFromJSONTyped(json, false);
}

export function ManageGmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManageGmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function ManageGmailResponseToJSON(json: any): ManageGmailResponse {
    return ManageGmailResponseToJSONTyped(json, false);
}

export function ManageGmailResponseToJSONTyped(value?: ManageGmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

